import { bottomTabbarId, commentsId } from 'fsrc/AddTaskWindow/config/constants.js';

export default (viewObject) => {
    const count = viewObject.getCount();
    const cellOption = $$(bottomTabbarId).getOption(commentsId);
    cellOption.value = `Комментарии (${count})`;
    $$(bottomTabbarId).refresh();
};
